import apiClient from '../client';
import type { Database } from '@/lib/supabase/supabase-types';

type User = Database['public']['Tables']['users']['Row'];
type UserUpdate = Database['public']['Tables']['users']['Update'];

export const userService = {
  /**
   * Get current user's profile
   */
  getMe: (): Promise<User> => apiClient.get<User>('/users/me') as unknown as Promise<User>,
  
  /**
   * Update current user's profile
   */
  updateMe: (data: UserUpdate): Promise<User> => 
    apiClient.patch<User>('/users/me', data) as unknown as Promise<User>,
  
  /**
   * Get display name for a user
   * @param userId - The user ID (Clerk ID)
   * @returns Display name, role, and profile picture URL
   */
  getDisplayName: (userId: string): Promise<{ display_name: string | null; role: 'freelancer' | 'client' | null; profile_picture_url: string | null }> =>
    apiClient.get<{ display_name: string | null; role: 'freelancer' | 'client' | null; profile_picture_url: string | null }>(`/users/${userId}/display-name`) as unknown as Promise<{ display_name: string | null; role: 'freelancer' | 'client' | null; profile_picture_url: string | null }>,
};

